export const SAVE = 'medicalAndEvacuationSCTIStep.SAVE';
export const VALUE_CHANGED = 'medicalAndEvacuationSCTIStep.VALUE_CHANGED';
export const LOAD = 'medicalAndEvacuationSCTIStep.VALUE_LOAD';
export const NEXT = 'medicalAndEvacuationSCTIStep.NEXT';
export const RESET = 'medicalAndEvacuationSCTIStep.RESET';
export const RESET_DAMAGED_LOST_EXPENSE = 'medicalAndEvacuationSCTIStep.RESET_DAMAGED_LOST_EXPENSE';
export const RESET_DELAYED_LUGGAGE_EXPENSE = 'medicalAndEvacuationSCTIStep.RESET_DELAYED_LUGGAGE_EXPENSE';
export const RESET_COMPENSATION = 'medicalAndEvacuationSCTIStep.RESET_COMPENSATION';
//-------------------------------------------------------
export const RESET_TRIP_CANCELLATION_STATE = 'medicalAndEvacuationSCTIStep.RESET_TRIP_CANCELLATION_STATE';
export const RESET_TRAVEL_INTERRUPTION_STATE = 'medicalAndEvacuationSCTIStep.RESET_TRAVEL_INTERRUPTION_STATE';
export const RESET_TRAVEL_DELAY_STATE = 'medicalAndEvacuationSCTIStep.RESET_TRAVEL_DELAY_STATE';
//------------------------------------------------------
export const RESET_FOR_DAMAGE_LOST_OR_STOLEN_LUGGAGE_STATE = 'medicalAndEvacuationSCTIStep.RESET_FOR_DAMAGE_LOST_OR_STOLEN_LUGGAGE_STATE';
export const RESET_FOR_BAGGAGE_DELAY_STATE = 'medicalAndEvacuationSCTIStep.RESET_TRAVEL_INTERRUPTION_STATE';
export const RESET_EUROPEAN_UNION_STATE = 'medicalAndEvacuationSCTIStep.RESET_EUROPEAN_UNION_STATE';
//------------------------------------------------------
export const RESET_MEDICAL_EXPENSES_STATE = 'medicalAndEvacuationSCTIStep.RESET_MEDICAL_EXPENSES_STATE';
export const RESET_DENTAL_EXPENSES_STATE = 'medicalAndEvacuationSCTIStep.RESET_DENTAL_EXPENSES_STATE';
export const RESET_FUNAREL_EXPENSES_STATE = 'medicalAndEvacuationSCTIStep.RESET_FUNAREL_EXPENSES_STATE';
export const RESET_HOSPITALISED_STATE = 'medicalAndEvacuationSCTIStep.RESET_HOSPITALISED_STATE';
export const RESET_ACCOMPANYING_PERSON_HOSPITALISED_STATE = 'medicalAndEvacuationSCTIStep.RESET_ACCOMPANYING_PERSON_HOSPITALISED_STATE';
export const RESET_THE_DEATH_CAUSED_BY_AN_INJURY_STATE = 'medicalAndEvacuationSCTIStep.RESET_ACCOMPANYING_PERSON_HOSPITALISED_STATE';
export const RESET_EXPENSES_ARISING_FROM_TERRORISM_STATE = 'medicalAndEvacuationSCTIStep.RESET_EXPENSES_ARISING_FROM_TERRORISM_STATE';
export const RESET_MEDICAL_HOSPITAL_EXPENSES1_STATE = 'medicalAndEvacuationSCTIStep.RESET_MEDICAL_HOSPITAL_EXPENSES1_STATE';
export const RESET_MEDICAL_HOSPITAL_EXPENSES2_STATE = 'medicalAndEvacuationSCTIStep.RESET_MEDICAL_HOSPITAL_EXPENSES2_STATE';
export const RESET_MEDICAL_HOSPITAL_EXPENSES3_STATE = 'medicalAndEvacuationSCTIStep.RESET_MEDICAL_HOSPITAL_EXPENSES3_STATE';
export const RESET_MEDICAL_HOSPITAL_EXPENSES4_STATE = 'medicalAndEvacuationSCTIStep.RESET_MEDICAL_HOSPITAL_EXPENSES4_STATE';
export const RESET_MEDICAL_HOSPITAL_EXPENSES5_STATE = 'medicalAndEvacuationSCTIStep.RESET_MEDICAL_HOSPITAL_EXPENSES5_STATE';
export const RESET_MEDICAL_HOSPITAL_EXPENSES6_STATE = 'medicalAndEvacuationSCTIStep.RESET_MEDICAL_HOSPITAL_EXPENSES6_STATE';
export const RESET_MEDICAL_HOSPITAL_EXPENSES7_STATE = 'medicalAndEvacuationSCTIStep.RESET_MEDICAL_HOSPITAL_EXPENSES7_STATE';
export const RESET_MEDICAL_HOSPITAL_EXPENSES8_STATE = 'medicalAndEvacuationSCTIStep.RESET_MEDICAL_HOSPITAL_EXPENSES8_STATE';
export const RESET_MEDICAL_HOSPITAL_EXPENSES9_STATE = 'medicalAndEvacuationSCTIStep.RESET_MEDICAL_HOSPITAL_EXPENSES9_STATE';
export const RESET_MEDICAL_HOSPITAL_EXPENSES10_STATE = 'medicalAndEvacuationSCTIStep.RESET_MEDICAL_HOSPITAL_EXPENSES10_STATE';
export const RESET_MEDICAL_HOSPITAL_EXPENSES11_STATE = 'medicalAndEvacuationSCTIStep.RESET_MEDICAL_HOSPITAL_EXPENSES11_STATE';
export const RESET_MEDICAL_HOSPITAL_EXPENSES12_STATE = 'medicalAndEvacuationSCTIStep.RESET_MEDICAL_HOSPITAL_EXPENSES12_STATE';
export const RESET_MEDICAL_HOSPITAL_EXPENSES13_STATE = 'medicalAndEvacuationSCTIStep.RESET_MEDICAL_HOSPITAL_EXPENSES13_STATE';
export const RESET_MEDICAL_HOSPITAL_EXPENSES14_STATE = 'medicalAndEvacuationSCTIStep.RESET_MEDICAL_HOSPITAL_EXPENSES14_STATE';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '20',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.MedicalAndEvacuation/constants.js